import { DataGrid } from "@mui/x-data-grid";

import TableNoDataOverlay from "../../../../../common/components/table/TableNoDataOverlay";
import { dataGridServerStyles } from "../../../../../common/providers/theme/design-tokens/DataGrid/dataGridServer.styles";
import { DEFAULT_COLUMN_HEADER_HEIGHT } from "../../../../../common/variables/common";
import { errorNotification } from "../../../../../common/variables/notification";
import { useDeviceTemplatesTableColumns } from "../hooks/useDeviceTemplatesTableColumns";
import { useDeviceTemplatesTableRows } from "../hooks/useDeviceTemplatesTableRows";
import { useDeleteDeviceTemplate } from "../hooks/useDeleteDeviceTemplate";

const DevicesTemplatesTable = (): JSX.Element => {
  const { rows, loading } = useDeviceTemplatesTableRows();
  const { columns } = useDeviceTemplatesTableColumns();
  const { loading: deleteDeviceTemplateLoading } = useDeleteDeviceTemplate();

  const handleProcessRowUpdateError = (): void => {
    errorNotification();
  };

  return (
    <DataGrid
      sx={{
        ...dataGridServerStyles.sx,
        "& .MuiDataGrid-row--editing": {
          boxShadow:
            "rgba(0, 0, 0, 0.2) -1px -1px 6px 2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px",
        },
      }}
      pageSizeOptions={[10]}
      rows={rows}
      columns={columns}
      slots={{
        noRowsOverlay: TableNoDataOverlay,
      }}
      columnHeaderHeight={DEFAULT_COLUMN_HEADER_HEIGHT}
      disableRowSelectionOnClick
      hideFooterSelectedRowCount
      getRowId={(row: { rowId?: string }): string => row?.rowId ?? ""}
      loading={loading || deleteDeviceTemplateLoading}
      sortingOrder={["desc", "asc"]}
      editMode="row"
      onProcessRowUpdateError={handleProcessRowUpdateError}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 10,
          },
        },
      }}
    />
  );
};

export default DevicesTemplatesTable;
